import { useTranslation } from "react-i18next";

import articleDeliveryTypes from "astrid-firestore/src/api/articles/constants/articleDeliveryTypes";

export default function useDeliveryTypeTranslations() {
	const { t } = useTranslation();

	return {
		[articleDeliveryTypes.METADATA]: t("meta", "Meta"),
		[articleDeliveryTypes.ARTIFACT]: t("files", "Files"),
	};
}
